import React, { useEffect, useState } from "react";
import Styles from "./emailVerification.module.scss";
import AuthSidebar from "../authSidebar/authSidebar";
import Illustration from "../../../assets/images/Verify_email_dashboard_illustration.svg";
import InformativeText from "../informativeText/informativeText";
import { callApi } from "../../../api/fetch";
import Loading from "../../../Shared/loading/loading";
import { ACCENTCOLOR } from "../../../Shared/colors";
import Toast from "../../../Shared/toast/toast";
import ErrorMessage from "../../../Shared/error-message/errorMessage";
import { useTitle } from "../../../Shared/useTitle";
import { testIdProps } from "../../../utils/testIdProps";

function EmailVerification() {
  const counter = Number(localStorage.getItem("resend_link_counter")) || 0;
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");
  const capitalizeFirstChar = (string: any) => {
    if (typeof string !== "string") return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  useEffect(() => {
    if (counter >= 3) {
      setError(
        "You have exhausted the number of retries for email verification"
      );
    }
  }, [counter]);
  function toastTimeout(
    showToastValue: boolean,
    toastType: "success" | "error",
    toastMessage: string | string[],
    heading?: string
  ) {
    if (!showToastValue) return;

    // Show toast via react-toastify
    Toast(
      toastType,
      toastMessage,
      heading || (toastType === "success" ? "Success" : "Error")
    );
  }
  const firstname = capitalizeFirstChar(localStorage.getItem("firstname"));
  async function handleResendVerificationLink() {
    setLoading(true);
    try {
      await callApi("/otp/send", {
        method: "POST",
        data: {
          purpose: "signup",
          email: localStorage.getItem("email"),
          is_consent_provided: true,
        },
      });
      setLoading(false);
      toastTimeout(
        true,
        "success",
        "Verification OTP sent. Continue signup and enter the OTP from your email."
      );
    } catch (err) {
      setLoading(false);
      toastTimeout(true, "error", (err as Error).message);
    }
  }
  useTitle("Zoop Customer Platform | Email Verification");
  return (
    <div className="container-fluid p-0">
      <div className="row no-gutters">
        <div className="col-xl-5 d-none d-xl-block">
          <AuthSidebar
            img={<img src={Illustration} alt="illustration" width="250px" />}
            info={<InformativeText headertext="One Identity Platform." />}
          />
        </div>
        <div className="col-xl-7 col-lg-12">
          <div className={`${Styles.authActionsBackground}`}>
            <div
              style={{ height: "100%" }}
              className="d-flex align-items-center justify-content-center"
            >
              <div>
                <p className={`${Styles.welcomeMessage} mb-0 text-center`}>
                  Hi {firstname}
                </p>
                <div className="py-4 text-center">
                  <p className={`${Styles.bodyText} mb-1`}>
                    We have sent you an email on{" "}
                    <span className={`${Styles.email}`}>
                      {localStorage.getItem("email")}
                    </span>
                  </p>
                  <p className={`${Styles.bodyText} mb-1`}>
                    Verify by clicking on the link in the email and become a
                    part of our ZOOP.ONE family
                  </p>
                </div>
                {error ? (
                  <div className="py-4 d-flex justify-content-center">
                    <ErrorMessage>{error}</ErrorMessage>
                  </div>
                ) : (
                  <div className="py-4">
                    <p
                      className={`${Styles.bodyText} mb-1`}
                      style={{ fontSize: "12px" }}
                    >
                      Not received the verification email?
                    </p>
                    {loading ? (
                      <Loading
                        loadingColor={ACCENTCOLOR}
                        width="10px"
                        height="10px"
                      />
                    ) : (
                      <p
                        {...testIdProps("resend-email")}
                        className={`${Styles.linkText} mb-0`}
                        onClick={() => {
                          if (counter >= 3) {
                            setError(
                              "You have exhausted the number of retries for email verification"
                            );
                            return;
                          }
                          localStorage.setItem(
                            "resend_link_counter",
                            (Number(counter) + 1).toString()
                          );
                          handleResendVerificationLink();
                        }}
                      >
                        Resend Email
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmailVerification;
